import {Button} from 'antd';

import {Text} from '../../../../../component/text/text';
import {Locale} from '../../../../../provider/locale/locale';
import {TelegramAccountType} from '../../../../../service/notifications-settings/notifications-settings-type';
import {classNames} from '../../../../../util/css';
import {useTelegramDisconnectModal} from '../deactivation-modal/deactivation-modal';

import * as styles from './account-card.scss';

type PropsType = {
    account: TelegramAccountType;
    activationLink: string;
    refetch: () => void;
};

export function AccountCard(props: PropsType): JSX.Element {
    const {account, activationLink, refetch} = props;
    const showDisconnectModal = useTelegramDisconnectModal(account, refetch);

    return (
        <div className={styles.AccountCard_accountCard} key={account.id}>
            <Text block bold className={styles.AccountCard_name}>
                {account.displayName}
            </Text>
            <Text
                block
                className={classNames(styles.AccountCard_status, {
                    [styles.AccountCard_status_deactivated]: account.isBlocked,
                })}
            >
                {account.isBlocked ? (
                    <Locale stringKey="NOTIFICATIONS__TELEGRAM_ANALYTICS__DEACTIVATED" />
                ) : (
                    <Locale stringKey="NOTIFICATIONS__TELEGRAM_ANALYTICS_ACTIVATED" />
                )}
            </Text>
            {account.isBlocked ? (
                <Button href={activationLink} size="small" target="_blank" type="primary">
                    <Locale stringKey="NOTIFICATIONS__TELEGRAM_ANALYTICS__ACTIVATE_ACCOUNT" />
                </Button>
            ) : (
                <Button danger onClick={showDisconnectModal} size="small" type="default">
                    <Locale stringKey="NOTIFICATIONS__TELEGRAM_ANALYTICS__DEACTIVATE_ACCOUNT" />
                </Button>
            )}
        </div>
    );
}
